<template>
  <div>
    <table class="table table-bordered">
      <tr>
        <th colspan="2" class="pl-0">
          <strong>{{ $t("Order:") }}</strong>
        </th>
      </tr>
      <tr>
        <td>{{ $t("Order ID") }}</td>
        <td>{{ order.orderID }}</td>
      </tr>
      <tr>
        <td>{{ $t("Created by") }}</td>
        <td>{{ order.userCreated }}</td>
      </tr>
      <tr>
        <td>{{ $t("Comments") }}</td>
        <td>{{ order.comment }}</td>
      </tr>
      <tr>
        <th colspan="2" class="pl-0">
          <strong>{{ $t("Delivery address:") }}</strong>
        </th>
      </tr>
      <tr>
        <td>{{ $t("Street") }}</td>
        <td>{{ order.shipmentStreet }}</td>
      </tr>
      <tr>
        <td>{{ $t("Number") }}</td>
        <td>{{ order.shipmentHouseNumber }}</td>
      </tr>
      <tr>
        <td>{{ $t("Zipcode") }}</td>
        <td>{{ order.shipmentZipCode }}</td>
      </tr>
      <tr>
        <td>{{ $t("City") }}</td>
        <td>{{ order.shipmentCity }}</td>
      </tr>
      <tr>
        <td>{{ $t("Country") }}</td>
        <td>{{ order.shipmentCountryID }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
};
</script>
